module.exports = __webpack_public_path__ + "img/087_thumbnail.72efb0cc.jpg";